import React from 'react';
import iPhone from '../../Media/Iphone-identified-v3.jpg'
import monograph from '../../Media/monograph-v3.jpg'

const Section3 = () => {
    return (
        <div>
            <div className='w-10/12 mx-auto text-center py-10'>
                <h3 className='text-xl text-gray-700'>— EST. 1994 —</h3>
                <h3 className='text-2xl font-semibold text-gray-700 my-5'>For over 25 years, PEPID has been a leading developer of clinical and drug information resources and mobile applications for healthcare providers, hospitals, and schools.</h3>
                <h2 className='md:text-5xl text-3xl font-bold text-primary-600'>PEPID HAS ALL THE TOOLS YOU NEED TO GET THE JOB DONE RIGHT.</h2>
                <button className='text-2xl font-bold text-white bg-red-500 hover:bg-red-600 px-6 py-2 rounded-full my-5'>SUBSCRIBE</button>
                <h2 className='md:text-5xl text-3xl font-bold text-primary-600'>MEDICAL CONTENT AND TOOLS</h2>
                <img src={iPhone} alt="" />
            </div>
            <div className=''>
                <img src={monograph} alt="" />
            </div>
        </div>
    );
};

export default Section3;